<template>
  <!-- eslint-disable  max-len -->
  <div
    id="sms-authenticator"
    class="configuration"
  >
    <div class="flex-grid">
      <div class="column--two">
        <div
          v-show="!isActivateMode"
          class="configuration__heading"
        >
          SMS is configured to handle your second-factor authentications.
        </div>
        <div class="configuration__description">
          <div>
            The SMS authenticator solution allows users to accept or deny a text message
            authentication by replying with either ‘yes' or ‘no.’
          </div>
          <div>
            Phone numbers are required for a user to use SMS as a second factor of authentication.
          </div>
        </div>
        <div class="configuration__description configuration__description--disclaimer">
          <div>
            Please note: Some mobile carriers do not support our current method for SMS
            authentication.
          </div>
          <div>
            Your experience may vary based on your carrier. Standard messaging rates apply.
            Opting-in to this method will send messages for authentication purposes only. No
            marketing content will ever be sent via this.
          </div>
        </div>
      </div>
      <div class="column--two">
        <div class="mb-1">
          The default authenticator will handle 2FA account-wide.
        </div>
        <label
          class="checkbox mb-1 ml-1"
          for="default-authenticator-check"
        >
          <input
            id="default-authenticator-check"
            v-model="defaultAuthenticatorCheck"
            type="checkbox"
          />
          <span>Set as Default Authenticator & Opt-in</span>
        </label>
        <div class="mt-2">
          <button
            id="cancel-button-sms"
            class="btn btn--grey mr-2"
            @click="emitCancel"
          >
            Cancel
          </button>
          <button
            id="submit-button-sms"
            class="btn"
            :disabled="!isDefault && !defaultAuthenticatorCheck"
            @click="update"
          >
            {{ isActivateMode ? "Activate" : "Update" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- eslint-enable  max-len -->
</template>

<script>
import AuthenticatorMixin from '@/mixins/authenticatorMixin'
export default {
  name: 'SmsConfiguration',
  mixins: [AuthenticatorMixin],
  props: [
    'selectedAuthenticator',
    'defaultAuthenticator',
    'isActivateMode',
    'parentError',
    'loading',
  ],
  data() {
    return {
      defaultAuthenticatorCheck: false,
    }
  },
  computed: {
    isDefault() {
      return this.isDefaultAuthenticator(this.defaultAuthenticator, this.AUTH_TYPES.SMS)
    },
  },
  created() {
    this.defaultAuthenticatorCheck = this.isDefault
  },
  methods: {
    update() {
      const _accountSettingPayload = this.generateSettingsPayload(
        this.defaultAuthenticatorCheck,
        this.AUTH_TYPES.SMS,
        null,
      )
      this.$emit('update-setting', _accountSettingPayload)
    },
    emitCancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="scss" scoped>
.configuration {
  &__heading {
    font-weight: 600;
    margin-bottom: 1em;
  }
  &__description {
    margin-bottom: 1em;
    font-size: $small-font;
    line-height: 1.5em;
    &--disclaimer {
      color: $grey-text;
      font-style: italic;
    }
  }
}
</style>
